<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="12" lg="12" class="text-center p-2">
                        <CRow>
                            <CCol sm="6">
                                <div class="p-2 text-left">
                                    <h3 class="custom-18px-500 text-left">Notification Settings</h3>
                                </div>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <CRow v-for="item in noti" v-bind:key="item.Id">
                            <CCol sm="10">
                                <CRow class="text-left">
                                    <CCol sm="1">
                                        <div class="text-center">
                                            <img src="../assets/img/phone-notification.png" width="30px" />
                                        </div>
    
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">{{ item.name }} Notification</label>
                                    </CCol>
                                </CRow>
    
                            </CCol>
                            <CCol sm="2">

                                <CSwitch color="primary" class="mx-1 custom-border-purple mt-1" name="switch1" :checked="item.status" @update:checked="UpdateStatus(item.id, $event)" shape="pill" />
                              
                                <!-- <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" :checked="item.status" @update:checked="UpdateStatus(item.id, $event)"/> -->
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>

                          
                        </CRow>
    
    
                    </CCol>
    
                </CRow>
            </CCard>

            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
        </CCol>
     
    </div>
</template>




<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {

            isPopupSuccess:false,
            noti: {}


        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetListNotification();

            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        async GetListNotification() {
            try {
                const response = await this.$API.get(this.$GetListSettingNotification, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.noti = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToSetting()
        {
            this.$router.push("Setting");
        },
        UpdateStatus: function(Id, checked) {
            const formData = new FormData();

            formData.append("NotiId", Id);
            formData.append("Status", checked ? "true" : "false");

            return this.$API
                .post(this.$InsertNotificationSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupSuccess = true;
                        this.GetListNotification();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
        }



    }

};
</script>